/* tslint:disable */
/* eslint-disable */
/**
 * Your Project API
 * Your project description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImageUrl
 */
export interface ImageUrl {
    /**
     * 
     * @type {string}
     * @memberof ImageUrl
     */
    url: string;
}

export function ImageUrlFromJSON(json: any): ImageUrl {
    return ImageUrlFromJSONTyped(json, false);
}

export function ImageUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImageUrl {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function ImageUrlToJSON(value?: ImageUrl | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}

